export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 2,
				text: "Die Pünktlichkeit und Regelmäßigkeit der Veranstaltung war gut.",
			},
			{
				id: 3,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 4,
				text: "Das behandelte Thema ist für meine berufliche, universitäre und/oder persönliche Entwicklung relevant. ",
			},
			{
				id: 5,
				text: "In der Veranstaltung wurden fächerübergreifende Bezüge hergestellt.",
			},
			{
				id: 6,
				text: "In der Veranstaltung wurden Bezüge zu aktuellen Themen hergestellt.",
			},
			{
				id: 7,
				text: "Die Qualität der Unterrichtsmaterialien und -medien war gut.",
			},
			{
				id: 8,
				text: "Es wurden Anregungen zum vertiefenden Studium gegeben (z.B. Skripte, Weblinks).",
			},
			{
				id: 9,
				text: "Die Qualität des Unterrichtsraums und der technischen Ausstattung war gut.",
			},
			{
				id: 10,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 11,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 12,
				text: "Die Online-Termine waren gut organisiert.",
			},
			{
				id: 13,
				text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
			},
			{
				id: 14,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 15,
				text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
			},
			{
				id: 16,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 17,
				text: "Die Schwierigkeit des Stoffes war...",
			},
			{
				id: 18,
				text: "Das Tempo der Veranstaltung war...",
			},
			{
				id: 19,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 20,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 21,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 22,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 23,
				text: "Anmerkungen: Besonders gut fand ich",
			},
			{
				id: 24,
				text: "Anmerkungen: Störend fand ich",
			},
			{
				id: 25,
				text: "Anmerkungen: Verbesserungsvorschläge",
			},
		],
	},
	{
		type: "dsp",
		id: 5,
		items: [
			{
				id: 26,
				text: "Der Dozent/Die Dozentin war fachlich kompetent.",
			},
			{
				id: 27,
				text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 28,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 29,
				text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
			},
			{
				id: 30,
				text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
			},
		],
	},
];
